<template>
  <section class="theme-breakdown" :class="{ desktop: $isDesktop }">
    <translate tag="h4" :tt="{ campsiteName, mean, breakdownName }">
      {mean, number, percent} described {campsiteName} as {breakdownName}
    </translate>

    <div class="theme-breakdown-table">
      <span v-for="(item, index) in breakdown.themes" :key="index">
        <span class="row">
          <span>{{ item.name }}</span>
          <span class="pc">{{ Math.round(item.mean) }}%</span>
        </span>
        <span class="bar">
          <span class="bar-value" :style="{ width: item.mean + '%' }" />
        </span>
      </span>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { ThemeBreakdown } from '../types'

@Component
class PuThemeBreakdown extends Vue {
  @Prop()
  campsiteName: string

  @Prop({ required: true })
  breakdown: ThemeBreakdown

  get breakdownName() {
    return this.breakdown.top!.name
  }

  get mean() {
    return Math.round(this.breakdown.top!.mean) / 100
  }
}

export default toNative(PuThemeBreakdown)
</script>

<style scoped>
.theme-breakdown {
  padding: 1.5em 2em 1em 2em;
}

.theme-breakdown h4 {
  color: var(--colour-dark-blue);
  font-weight: normal;
  line-height: 1.3;
  padding-right: 0.5em;
  text-wrap-style: balance;
}

h4 :deep(span) {
  font-weight: bold;
}

.theme-breakdown h4 :deep(em) {
  font-weight: bold;
}

.theme-breakdown-table {
  font-size: 0.85em;
  width: auto;
  margin: 1.5em auto;
}

.pc {
  margin-left: auto;
  color: var(--colour-text-light);
}

.bar {
  background-color: var(--colour-pale-blue);
  width: 100%;
  height: 10px;
  position: relative;
  display: block;
  margin: 1px 0 12px;
  border-radius: 2em;
}

.bar-value {
  background-color: var(--colour-orange);
  width: 0;
  height: 10px;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 2em;
}

.desktop.theme-breakdown {
  padding: 2em 2.5em 2em;
}

.desktop.theme-breakdown h4 {
  font-size: 1.3em;
}

.desktop.theme-breakdown .theme-breakdown-table {
  font-size: initial;
}
</style>
